/**
 * Update date: 25-05-2023
 * Screen 2042.2
 */
import PopupSelectCommonCode from 'app/components/PopupCommon/PopupSelectCommonCode';
import Form from 'devextreme-react/form';
import React, { useState, useRef } from 'react';
import moment from 'moment';
import { useInquiresAbout } from '..';
import { uniqBy } from 'lodash';
import PopupSelectProduct from 'app/components/PopupCommon/PopupSelectProduct';
import PopupSelectProductGroup from 'app/components/PopupCommon/PopupSelectProductGroup';
import DateOptions from 'app/components/DateOptions';
import PopupSelectVendor from 'app/components/PopupCommon/PopupSelectVendor';
import Collapse from 'app/components/Collapse';
import useFormatTime from 'hooks/useFormatTime';
import useDictionary from 'hooks/useDictionary';
const listTypeCommon = {
  vendor: {
    codeType: 'VD',
    title: 'Search Vendor',
  },
  product: {
    codeType: 'PD',
    title: 'Search Product',
  },
  productGroup: {
    codeType: 'PG',
    title: 'Search ProductGroup',
  },
  largeCategories: {
    codeType: 'LC',
    title: 'Search Large Category',
  },
  mediumCategories: {
    codeType: 'MC',
    title: 'Search Medium Category',
  },
  smallCategories: {
    codeType: 'SC',
    title: 'Search Small Category',
  },
  subCategories: {
    codeType: 'UC',
    title: 'Search Sub Category',
  },
  vendorType: {
    codeType: 'VT',
  },
};

const FormSearch = () => {
  const context: any = useInquiresAbout();
  const { params, setParams, refetchData, setDataLocal } = context;
  const [showPopupByType, setShowPopupByType] = useState('');

  const formRef: any = useRef(null);
  const { DateFormat } = useFormatTime();
  const { t }: any = useDictionary({
    programId: '2042.2',
  });
  /**
   * on submit
   *
   * @return {*}
   */
  const onSubmit = () => {
    const isValid = formRef?.current?.instance?.validate()?.isValid;
    if (isValid === false) return;
    const data = {
      largeCategories: params?.formStore.largeCategories.map(
        (map: any) => map?.code,
      ),
      mediumCategories: params?.formStore.mediumCategories.map(
        (map: any) => map?.code,
      ),
      smallCategories: params?.formStore.smallCategories.map(
        (map: any) => map?.code,
      ),
      subCategories: params?.formStore.subCategories.map(
        (map: any) => map?.code,
      ),
      productIds: params?.formStore.product.map((map: any) => map?.productId),
      productGroupIds: params?.formStore.productGroup.map(
        (map: any) => map?.productGroupId,
      ),
      vendorIds: params?.formStore.vendor.map((map: any) => map?.vendorId),
      vendorTypes: params?.formStore?.vendorType?.map(o => o?.code),
      fromDate: params.fromDate
        ? moment(params.fromDate).format('YYYY-MM-DD')
        : null,
      endDate: params.endDate
        ? moment(params.endDate).format('YYYY-MM-DD')
        : null,
      status: params.status,
    };
    refetchData({
      data,
    });
  };

  // Onchange date when choose date option
  const onChangeDate = (fromDateValue, toDateValue) => {
    if (!fromDateValue || !toDateValue) return;
    formRef?.current?.instance?.updateData('fromDate', fromDateValue);
    formRef?.current?.instance?.updateData('endDate', toDateValue);
  };
  /**
   * on field data change
   *
   * @param {*} e
   */
  const onFieldDataChanged = e => {
    switch (e?.dataField) {
      case 'fromDate':
        if (params.endDate && e?.value && e?.value > params.endDate)
          formRef?.current?.instance.updateData('endDate', null);
        break;
      case 'endDate':
        if (params.fromDate && e?.value && e?.value < params.fromDate)
          formRef?.current?.instance.updateData('fromDate', null);
        break;
      default:
        break;
    }
  };
  /**
   * render popup by type
   *
   * @param {string} popupType
   * @return {*}
   */
  const getPopupByType = (popupType: string) => {
    switch (popupType) {
      case 'vendor':
        return (
          <PopupSelectVendor
            text={params?.[popupType]}
            mode="multiple"
            visible={showPopupByType === popupType}
            onHiding={() => setShowPopupByType('')}
            onSubmit={data => updateStore(popupType, data, 'vendorId')}
          />
        );
      case 'product':
        return (
          <PopupSelectProduct
            visible={!!listTypeCommon?.[popupType]?.codeType}
            text={params?.[popupType]}
            onHiding={() => setShowPopupByType('')}
            mode="multiple"
            onSubmit={data => updateStore(popupType, data, 'productId')}
          />
        );
      case 'productGroup':
        return (
          <PopupSelectProductGroup
            visible={!!listTypeCommon?.[popupType]?.codeType}
            text={params?.[popupType]}
            onHiding={() => setShowPopupByType('')}
            mode="multiple"
            onSubmit={data => updateStore(popupType, data, 'productGroupId')}
          />
        );
      case 'largeCategories':
      case 'mediumCategories':
      case 'smallCategories':
      case 'subCategories':
      case 'vendorType':
        return (
          <PopupSelectCommonCode
            visible={!!listTypeCommon?.[popupType]?.codeType}
            text={params?.[popupType]}
            codeType={listTypeCommon?.[popupType]?.codeType}
            mode="multiple"
            onHiding={() => setShowPopupByType('')}
            onSubmit={data => updateStore(popupType, data, 'code')}
          />
        );
      default:
        return null;
    }
  };

  /**
   * on update store
   *
   * @param {*} popupType
   * @param {*} data
   * @param {*} [key=false]
   */
  const updateStore = (popupType, data, key: any = false) => {
    const filterData = uniqBy(
      [...params?.formStore?.[popupType], ...data],
      key,
    );
    const newStore = { ...params?.formStore, [popupType]: filterData };
    setParams(preState => ({
      ...preState,
      [popupType]: '',
      formStore: newStore,
    }));
    setShowPopupByType('');
    if (popupType === 'vendorType') {
      setDataLocal(preState => ({
        ...preState,
        vendorType: filterData,
      }));
    }
  };
  /**
   * on remove store
   *
   * @param {*} popupType
   * @param {*} index
   */
  const removeStore = (popupType, index) => {
    let newStore: any = [];
    if (index === -1) {
      setParams(preState => ({
        ...preState,
        formStore: {
          ...preState?.formStore,
          [popupType]: [],
        },
      }));
    } else {
      const l = [...params?.formStore[popupType]];
      newStore = [...l.slice(0, index), ...l.slice(index + 1)];
      setParams(preState => ({
        ...preState,
        formStore: {
          ...preState?.formStore,
          [popupType]: newStore,
        },
      }));
    }
    if (popupType === 'vendorType') {
      setDataLocal(preState => ({
        ...preState,
        vendorType: newStore,
      }));
    }
  };
  /**
   * render search
   *
   * @param {*} { name }
   * @return {*}
   */
  const Search = ({ name }) => {
    return (
      <>
        <DateOptions
          onChangeValue={(fromDate, toDate) => onChangeDate(fromDate, toDate)}
        />
        <Form
          ref={formRef}
          formData={params}
          showColonAfterLabel={false}
          items={[
            {
              dataField: 'fromDate',
              editorType: 'dxDateBox',
              label: {
                text: t('From Date'),
              },
              editorOptions: {
                displayFormat: DateFormat,
              },
            },
            {
              dataField: 'endDate',
              editorType: 'dxDateBox',
              label: {
                text: t('End Date'),
              },
              editorOptions: {
                displayFormat: DateFormat,
              },
            },
            {
              label: { text: t('Status') },
              dataField: 'status',
              editorType: 'dxSelectBox',
              colSpan: 2,
              editorOptions: {
                readOnly: true,
                displayExpr: 'label',
                valueExpr: 'value',
                defaultValue: '',
                items: [
                  { label: t('All'), value: '' },
                  { label: t('Pending'), value: '0' },
                  { label: t('Fixed'), value: '1' },
                ],
              },
            },
            {
              label: { text: t('Vendor') },
              dataField: 'vendor',
              editorType: 'dxTextBox',
              colSpan: 2,
              editorOptions: {
                onEnterKey: () => setShowPopupByType('vendor'),
                buttons: [
                  {
                    name: 'data1',
                    location: 'before',
                    options: {
                      icon: 'close',
                      text: params?.formStore?.vendor[0]?.vendorName,
                      onClick: () => removeStore('vendor', 0),
                      visible: !!params?.formStore?.vendor[0]?.vendorId,
                      rtlEnabled: true,
                    },
                  },
                  {
                    name: 'data2',
                    location: 'before',
                    options: {
                      icon: 'close',
                      text: params?.formStore?.vendor[1]?.vendorName,
                      onClick: () => removeStore('vendor', 1),
                      visible: !!params?.formStore?.vendor[1]?.vendorId,
                      rtlEnabled: true,
                    },
                  },
                  {
                    name: 'dataMore',
                    location: 'before',
                    options: {
                      text: `+ ${params?.formStore?.vendor?.length - 2} ${t(
                        'more',
                      )}`,
                      visible: params?.formStore?.vendor?.length > 2,
                    },
                  },
                  {
                    name: 'clearAll',
                    location: 'after',
                    options: {
                      stylingMode: 'text',
                      icon: 'close',
                      visible: !!params?.formStore?.vendor?.length,
                      onClick: () => removeStore('vendor', -1),
                    },
                  },
                  {
                    name: 'search',
                    location: 'after',
                    options: {
                      stylingMode: 'text',
                      icon: 'search',
                      onClick: () => setShowPopupByType('vendor'),
                    },
                  },
                ],
              },
            },
            {
              dataField: 'vendorType',
              editorType: 'dxTextBox',
              label: { text: t('Vendor Type') },
              colSpan: 2,
              editorOptions: {
                onEnterKey: () => {
                  setShowPopupByType('vendorType');
                },
                buttons: [
                  {
                    name: 'data1',
                    location: 'before',
                    options: {
                      icon: 'close',
                      text: params?.formStore?.vendorType[0]?.name,
                      onClick: () => removeStore('vendorType', 0),
                      visible: !!params?.formStore?.vendorType[0]?.code,
                      rtlEnabled: true,
                    },
                  },
                  {
                    name: 'data2',
                    location: 'before',
                    options: {
                      icon: 'close',
                      text: params?.formStore?.vendorType[1]?.name,
                      onClick: () => removeStore('vendorType', 1),
                      visible: !!params?.formStore?.vendorType[1]?.code,
                      rtlEnabled: true,
                    },
                  },
                  {
                    name: 'storeMore',
                    location: 'before',
                    options: {
                      text: `+ ${params?.formStore?.vendorType?.length - 2} ${t(
                        'more',
                      )}`,
                      visible: params?.formStore?.vendorType?.length > 2,
                    },
                  },
                  {
                    name: 'clearAll',
                    location: 'after',
                    options: {
                      stylingMode: 'text',
                      icon: 'close',
                      visible: !!params?.formStore?.vendorType?.length,
                      onClick: () => removeStore('vendorType', -1),
                    },
                  },
                  {
                    name: 'search',
                    location: 'after',
                    options: {
                      stylingMode: 'text',
                      icon: 'search',
                      onClick: () => setShowPopupByType('vendorType'),
                    },
                  },
                ],
              },
            },
          ]}
          labelLocation="top"
          onFieldDataChanged={onFieldDataChanged}
          colCount={4}
        ></Form>
      </>
    );
  };
  /**
   * render advanced search
   *
   * @param {*} { name }
   * @return {*}
   */
  const AdvancedSearch = ({ name }) => {
    return (
      <>
        <Form
          formData={params}
          showColonAfterLabel={false}
          items={[
            {
              label: { text: t('Large Category') },
              dataField: 'largeCategories',
              editorType: 'dxTextBox',
              editorOptions: {
                onEnterKey: () => setShowPopupByType('largeCategories'),
                buttons: [
                  {
                    name: 'data1',
                    location: 'before',
                    options: {
                      icon: 'close',
                      text: params?.formStore?.largeCategories[0]?.name,
                      onClick: () => removeStore('largeCategories', 0),
                      visible: !!params?.formStore?.largeCategories[0]?.code,
                      rtlEnabled: true,
                    },
                  },
                  {
                    name: 'data2',
                    location: 'before',
                    options: {
                      icon: 'close',
                      text: params?.formStore?.largeCategories[1]?.name,
                      onClick: () => removeStore('largeCategories', 1),
                      visible: !!params?.formStore?.largeCategories[1]?.code,
                      rtlEnabled: true,
                    },
                  },
                  {
                    name: 'dataMore',
                    location: 'before',
                    options: {
                      text: `+ ${
                        params?.formStore?.largeCategories?.length - 2
                      } ${t('more')}`,
                      visible: params?.formStore?.largeCategories?.length > 2,
                    },
                  },
                  {
                    name: 'clearAll',
                    location: 'after',
                    options: {
                      stylingMode: 'text',
                      icon: 'close',
                      visible: !!params?.formStore?.largeCategories?.length,
                      onClick: () => removeStore('largeCategories', -1),
                    },
                  },
                  {
                    name: 'search',
                    location: 'after',
                    options: {
                      stylingMode: 'text',
                      icon: 'search',
                      onClick: () => setShowPopupByType('largeCategories'),
                    },
                  },
                ],
              },
            },
            {
              label: { text: t('Medium Category') },
              dataField: 'mediumCategories',
              editorType: 'dxTextBox',
              editorOptions: {
                onEnterKey: () => setShowPopupByType('mediumCategories'),
                buttons: [
                  {
                    name: 'data1',
                    location: 'before',
                    options: {
                      icon: 'close',
                      text: params?.formStore?.mediumCategories[0]?.name,
                      onClick: () => removeStore('mediumCategories', 0),
                      visible: !!params?.formStore?.mediumCategories[0]?.code,
                      rtlEnabled: true,
                    },
                  },
                  {
                    name: 'data2',
                    location: 'before',
                    options: {
                      icon: 'close',
                      text: params?.formStore?.mediumCategories[1]?.name,
                      onClick: () => removeStore('mediumCategories', 1),
                      visible: !!params?.formStore?.mediumCategories[1]?.code,
                      rtlEnabled: true,
                    },
                  },
                  {
                    name: 'dataMore',
                    location: 'before',
                    options: {
                      text: `+ ${
                        params?.formStore?.mediumCategories?.length - 2
                      } ${t('more')}`,
                      visible: params?.formStore?.mediumCategories?.length > 2,
                    },
                  },
                  {
                    name: 'clearAll',
                    location: 'after',
                    options: {
                      stylingMode: 'text',
                      icon: 'close',
                      visible: !!params?.formStore?.mediumCategories?.length,
                      onClick: () => removeStore('mediumCategories', -1),
                    },
                  },
                  {
                    name: 'search',
                    location: 'after',
                    options: {
                      stylingMode: 'text',
                      icon: 'search',
                      onClick: () => setShowPopupByType('mediumCategories'),
                    },
                  },
                ],
              },
            },
            {
              label: { text: t('Product Group') },
              dataField: 'productGroup',
              editorType: 'dxTextBox',
              editorOptions: {
                onEnterKey: () => setShowPopupByType('productGroup'),
                buttons: [
                  {
                    name: 'data1',
                    location: 'before',
                    options: {
                      icon: 'close',
                      text: params?.formStore?.productGroup[0]?.productGroupNm,
                      onClick: () => removeStore('productGroup', 0),
                      visible:
                        !!params?.formStore?.productGroup[0]?.productGroupId,
                      rtlEnabled: true,
                    },
                  },
                  {
                    name: 'data2',
                    location: 'before',
                    options: {
                      icon: 'close',
                      text: params?.formStore?.productGroup[1]?.productGroupNm,
                      onClick: () => removeStore('productGroup', 1),
                      visible:
                        !!params?.formStore?.productGroup[1]?.productGroupId,
                      rtlEnabled: true,
                    },
                  },
                  {
                    name: 'dataMore',
                    location: 'before',
                    options: {
                      text: `+ ${
                        params?.formStore?.productGroup?.length - 2
                      } ${t('more')}`,
                      visible: params?.formStore?.productGroup?.length > 2,
                    },
                  },
                  {
                    name: 'clearAll',
                    location: 'after',
                    options: {
                      stylingMode: 'text',
                      icon: 'close',
                      visible: !!params?.formStore?.productGroup?.length,
                      onClick: () => removeStore('productGroup', -1),
                    },
                  },
                  {
                    name: 'search',
                    location: 'after',
                    options: {
                      stylingMode: 'text',
                      icon: 'search',
                      onClick: () => setShowPopupByType('productGroup'),
                    },
                  },
                ],
              },
            },
            {
              label: { text: t('Small Category') },
              dataField: 'smallCategories',
              editorType: 'dxTextBox',
              editorOptions: {
                onEnterKey: () => setShowPopupByType('smallCategories'),
                buttons: [
                  {
                    name: 'data1',
                    location: 'before',
                    options: {
                      icon: 'close',
                      text: params?.formStore?.smallCategories[0]?.name,
                      onClick: () => removeStore('smallCategories', 0),
                      visible: !!params?.formStore?.smallCategories[0]?.code,
                      rtlEnabled: true,
                    },
                  },
                  {
                    name: 'data2',
                    location: 'before',
                    options: {
                      icon: 'close',
                      text: params?.formStore?.smallCategories[1]?.name,
                      onClick: () => removeStore('smallCategories', 1),
                      visible: !!params?.formStore?.smallCategories[1]?.code,
                      rtlEnabled: true,
                    },
                  },
                  {
                    name: 'dataMore',
                    location: 'before',
                    options: {
                      text: `+ ${
                        params?.formStore?.smallCategories?.length - 2
                      } ${t('more')}`,
                      visible: params?.formStore?.smallCategories?.length > 2,
                    },
                  },
                  {
                    name: 'clearAll',
                    location: 'after',
                    options: {
                      stylingMode: 'text',
                      icon: 'close',
                      visible: !!params?.formStore?.smallCategories?.length,
                      onClick: () => removeStore('smallCategories', -1),
                    },
                  },
                  {
                    name: 'search',
                    location: 'after',
                    options: {
                      stylingMode: 'text',
                      icon: 'search',
                      onClick: () => setShowPopupByType('smallCategories'),
                    },
                  },
                ],
              },
            },
            {
              label: { text: t('Sub Category') },
              dataField: 'subCategories',
              editorType: 'dxTextBox',
              editorOptions: {
                onEnterKey: () => setShowPopupByType('subCategories'),
                buttons: [
                  {
                    name: 'data1',
                    location: 'before',
                    options: {
                      icon: 'close',
                      text: params?.formStore?.subCategories[0]?.name,
                      onClick: () => removeStore('subCategories', 0),
                      visible: !!params?.formStore?.subCategories[0]?.code,
                      rtlEnabled: true,
                    },
                  },
                  {
                    name: 'data2',
                    location: 'before',
                    options: {
                      icon: 'close',
                      text: params?.formStore?.subCategories[1]?.name,
                      onClick: () => removeStore('subCategories', 1),
                      visible: !!params?.formStore?.subCategories[1]?.code,
                      rtlEnabled: true,
                    },
                  },
                  {
                    name: 'dataMore',
                    location: 'before',
                    options: {
                      text: `+ ${
                        params?.formStore?.subCategories?.length - 2
                      } ${t('more')}`,
                      visible: params?.formStore?.subCategories?.length > 2,
                    },
                  },
                  {
                    name: 'clearAll',
                    location: 'after',
                    options: {
                      stylingMode: 'text',
                      icon: 'close',
                      visible: !!params?.formStore?.subCategories?.length,
                      onClick: () => removeStore('subCategories', -1),
                    },
                  },
                  {
                    name: 'search',
                    location: 'after',
                    options: {
                      stylingMode: 'text',
                      icon: 'search',
                      onClick: () => setShowPopupByType('subCategories'),
                    },
                  },
                ],
              },
            },
            {
              label: { text: t('Product') },
              dataField: 'product',
              editorType: 'dxTextBox',
              editorOptions: {
                onEnterKey: () => setShowPopupByType('product'),
                buttons: [
                  {
                    name: 'data1',
                    location: 'before',
                    options: {
                      icon: 'close',
                      text: params?.formStore?.product[0]?.productNm,
                      onClick: () => removeStore('product', 0),
                      visible: !!params?.formStore?.product[0]?.productId,
                      rtlEnabled: true,
                    },
                  },
                  {
                    name: 'data2',
                    location: 'before',
                    options: {
                      icon: 'close',
                      text: params?.formStore?.product[1]?.productNm,
                      onClick: () => removeStore('product', 1),
                      visible: !!params?.formStore?.product[1]?.productId,
                      rtlEnabled: true,
                    },
                  },
                  {
                    name: 'dataMore',
                    location: 'before',
                    options: {
                      text: `+ ${params?.formStore?.product?.length - 2} ${t(
                        'more',
                      )}`,
                      visible: params?.formStore?.product?.length > 2,
                    },
                  },
                  {
                    name: 'clearAll',
                    location: 'after',
                    options: {
                      stylingMode: 'text',
                      icon: 'close',
                      visible: !!params?.formStore?.product?.length,
                      onClick: () => removeStore('product', -1),
                    },
                  },
                  {
                    name: 'search',
                    location: 'after',
                    options: {
                      stylingMode: 'text',
                      icon: 'search',
                      onClick: () => setShowPopupByType('product'),
                    },
                  },
                ],
              },
            },
          ]}
          labelLocation="top"
          colCount={3}
        ></Form>
      </>
    );
  };
  return (
    <div>
      <Collapse onSubmit={onSubmit}>
        <Search name={t('Search')} />
        <AdvancedSearch name={t('Advanced Search')} />
      </Collapse>
      {getPopupByType(showPopupByType)}
    </div>
  );
};

export default FormSearch;
